module.exports = __webpack_public_path__ + "img/ic_launcher_round.8f0e48b9.png";